var React = require('react');

function FacebookLogo (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M21.125,0L4.875,0C2.182,0 0,2.182 0,4.875L0,21.125C0,23.818 2.182,26 4.875,26L21.125,26C23.818,26 26,23.818 26,21.125L26,4.875C26,2.182 23.818,0 21.125,0ZM20.464,14.002L18.031,14.002L18.031,23.006L13.968,23.006L13.968,14.002L12.392,14.002L12.392,10.969L13.968,10.969L13.968,9.037C13.969,6.504 15.021,5 18.006,5L21.031,5L21.031,8.022L19.274,8.022C18.112,8.022 18.036,8.455 18.036,9.265L18.031,10.968L20.795,10.968L20.464,14.002Z","style":{"fill":"white","fillRule":"nonzero"}})));
}

FacebookLogo.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 26 26","version":"1.1","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = FacebookLogo;

FacebookLogo.default = FacebookLogo;
